// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Projects section styles. */

.profile__section[data-profile-section='projects'],
.profile__section--empty[data-profile-section='projects'] {
  --project-card-rail-gap: var(--spacing-md, 1rem);
  --project-card-rail-wrap: nowrap;
  --project-card-rail-overflow-x: auto;
  --project-card-rail-scroll-snap-type: x proximity;
  --project-card-flex-basis: min(420px, 88vw);
  --project-card-flex: 0 0 var(--project-card-flex-basis);
  --project-card-max-width: none;
  --project-card-scrollbar-height: 0.5rem;
  --project-card-thumb-column-width: 88px;
  --project-card-thumb-size: 4.125rem;
  --project-card-follow-label-gap: var(--spacing-xxs, 0.3125rem);
  --project-card-wrapper-gap: var(--spacing-2xs, 0.625rem);
  --project-card-content-gap: var(--spacing-xxs, 0.3125rem);
  --project-card-heading-gap: 0.1875rem;
  --project-card-meta-margin-top: var(--spacing-xs, 0.75rem);
  --project-card-meta-font-size: 0.86rem;
  --project-card-footer-padding: var(--spacing-xs, 0.75rem);
  --project-card-more-button-gap: var(--spacing-xs, 0.375rem);
  --project-card-more-button-width: auto;
  --project-card-more-button-part-width: auto;
  --project-card-mobile-more-button-margin-top: var(--spacing-xs, 0.75rem);
  --project-card-more-button-margin-top: 0;
  --project-card-collapsed-extra-display: flex;
  --project-card-more-icon-transform: rotate(0deg);
}

/* Rail and cards */
.project-card__rail {
  display: flex;
  gap: var(--project-card-rail-gap);
  overflow-x: var(--project-card-rail-overflow-x, auto);
  padding: 0;
  margin: 0;
  list-style: none;
  flex-wrap: var(--project-card-rail-wrap, nowrap);
  scroll-snap-type: var(--project-card-rail-scroll-snap-type, x proximity);
}

solid-ui-button.project-card__follow-button {
  width: auto;
  min-width: 0;
  max-width: none;
  gap: var(--project-card-follow-label-gap);
  --button-border-width: var(--border-width-sm, 0.1rem);
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-font-weight: var(--font-weight-md, 500);
  --button-padding-sm: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);
  --button-border-radius: var(--border-radius-md, 0.5rem);
  --button-background: var(--color-card-bg, var(--white, #FFF));
  --button-text: var(--color-primary, #7C4DFF);
  --button-border: var(--color-primary, #7C4DFF);
  --button-hover-background: var(--color-primary, #7C4DFF);
  --button-hover-text: var(--color-text-on-action, var(--white, #FFF));
  --button-hover-border: var(--color-primary, #7C4DFF);
}

.project-card__follow-label {
  display: inline-flex;
  align-items: center;
  gap: var(--project-card-follow-label-gap);
}

.project-card__follow-label--hover {
  display: none;
}

.project-card__follow-label--loading {
  display: none;
  align-items: center;
  gap: var(--project-card-follow-label-gap);
}

solid-ui-button.project-card__follow-button:hover .project-card__follow-label--default,
solid-ui-button.project-card__follow-button:focus-visible .project-card__follow-label--default,
solid-ui-button.project-card__follow-button:focus-within .project-card__follow-label--default {
  display: none;
}

solid-ui-button.project-card__follow-button:hover .project-card__follow-label--hover,
solid-ui-button.project-card__follow-button:focus-visible .project-card__follow-label--hover,
solid-ui-button.project-card__follow-button:focus-within .project-card__follow-label--hover {
  display: inline-flex;
}

solid-ui-button.project-card__follow-button[data-loading='true'] {
  pointer-events: none;
}

solid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--default,
solid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--hover {
  display: none;
}

solid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--loading {
  display: inline-flex;
}

solid-ui-button.project-card__follow-button[data-loading='true'] .loading-spinner {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
  border-width: 0.125rem;
}

.project-card__rail::-webkit-scrollbar {
  height: var(--project-card-scrollbar-height);
}

.project-card__rail::-webkit-scrollbar-thumb {
  background: var(--color-icon-muted, #90A1B9);
  border-radius: 999px;
}

.project-card {
  display: flex;
  flex-direction: column;
  flex: var(--project-card-flex, 0 0 var(--project-card-flex-basis));
  width: 100%;
  max-width: var(--project-card-max-width, none);
  min-width: 0;
  box-sizing: border-box;
  scroll-snap-align: start;
  border-radius: var(--border-radius-md, 0.5rem);
  border: var(--border-width-sm, 0.1rem) solid var(--color-border, var(--gray-200, #E5E7EB));
  padding: var(--spacing-md, 1.25rem);
  justify-content: center;
  align-items: flex-start;
  gap: var(--spacing-sm, 0.938rem);
  flex-shrink: 0;
}

.project-card__link {
  display: block;
  width: 100%;
  align-self: stretch;
  color: inherit;
  text-decoration: none;
}

.project-card__link:hover .project-card__title,
.project-card__link:focus-visible .project-card__title {
  text-decoration: underline;
}

.project-card__wrapper {
  display: grid;
  grid-template-columns: var(--project-card-thumb-column-width) 1fr;
  gap: var(--project-card-wrapper-gap);
  width: 100%;
  align-items: start;
  border-radius: var(--border-radius-md, 0.5rem);
  border-bottom: 1px solid var(--color-border, var(--gray-200, #E5E7EB));
}

.project-card__thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--project-card-thumb-size);
  height: var(--project-card-thumb-size);
  overflow: hidden;
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--color-surface-placeholder, var(--gray-200, #E5E7EB));
  padding: 0.656rem var(--spacing-2xs, 0.625rem);
  aspect-ratio: 1/1;
}

.project-card__thumb-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.project-card__thumb-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 0.72rem;
  color: var(--color-text-detail, var(--slate-500, #62748E));
  text-transform: uppercase;
  letter-spacing: 0.04rem;
}

.project-card__content {
  display: flex;
  flex-direction: column;
  gap: var(--project-card-content-gap);
  min-width: 0;
}

.project-card__heading-group {
  display: flex;
  flex-direction: column;
  gap: var(--project-card-heading-gap);
  min-width: 0;
}

.project-card__title,
.project-card__organization,
.project-card__category,
.project-card__meta,
.project-card__description {
  margin: 0;
}

.project-card__title {
  overflow: hidden;
  color: var(--color-text-subheading, var(--gray-900, #101828));
  text-overflow: ellipsis;
  font-size: var(--font-size-lg, 1.125rem);
  font-weight: var(--font-weight-bold, 600);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  align-self: stretch;
}

.project-card__organization {
  color: var(--color-text-primary, var(--gray-700, #364153));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: 1.35;
  align-self: stretch;
}

.project-card__category {
  font-size: var(--font-size-xxs, 0.75rem);
  font-weight: var(--font-weight-md, 500);
}

.project-card__category--project {
  color: var(--purple-500, #AD46FF);
}

.project-card__category--community {
  color: var(--yellow-700, #A65F00);
}

.project-card__category--unknown {
  color: var(--color-text-control, var(--slate-700, #314158));
}

.project-card__meta {
  margin-top: var(--project-card-meta-margin-top);
  overflow-wrap: anywhere;
  font-size: var(--project-card-meta-font-size, 0.86rem);
}

.project-card__footer {
  display: flex;
  justify-content: flex-start;
  align-self: stretch;
  margin-top: auto;
  padding: var(--spacing-sm, 0.938rem) 0 0;
}

.profile__section[data-profile-section='projects'] .profile-section-inline-error {
  margin-top: var(--spacing-sm, 0.938rem);
  padding: var(--spacing-xs, 0.75rem);
  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--dialog-error-background, var(--pink-500, #ffdde6));
  color: var(--dialog-error-text, var(--red-600, #B00020));
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* Action buttons */

solid-ui-button.project-card__more-button {
  width: var(--project-card-more-button-width, auto);
  margin-top: var(--project-card-more-button-margin-top, 0);
  --button-height-sm: 0;
  --button-padding-x-sm: 0;
  --button-background: transparent;
  --button-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
}

.project-card__more-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: var(--project-card-more-icon-transform, rotate(0deg));
  transition: transform var(--animation-duration, 0.2s) ease;
}

solid-ui-button.project-card__more-button::part(button) {
  align-items: center;
  justify-content: center;
  width: var(--project-card-more-button-part-width, auto);
  gap: var(--project-card-more-button-gap, 0.375rem);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-primary, #7C4DFF);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-bold, 600);
  cursor: var(--profile-interactive-cursor, pointer);
}

/* Compact layout */
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='projects'],
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='projects'] {
  --project-card-rail-wrap: wrap;
  --project-card-rail-overflow-x: visible;
  --project-card-rail-scroll-snap-type: none;
  --project-card-flex: 1 1 100%;
  --project-card-max-width: 100%;
  --project-card-more-button-width: 100%;
  --project-card-more-button-part-width: 100%;
  --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));
}

.profile-section-collapsible[data-mobile-expanded="false"] .project-card:nth-child(n + 3) {
  display: var(--project-card-collapsed-extra-display, flex);
}

solid-ui-button.project-card__more-button[data-mobile-expanded="true"] .project-card__more-icon {
  --project-card-more-icon-transform: rotate(180deg);
}

@media (max-width: 576px) {
  .profile__section[data-profile-section='projects'],
  .profile__section--empty[data-profile-section='projects'] {
    --project-card-rail-wrap: wrap;
    --project-card-rail-overflow-x: visible;
    --project-card-rail-scroll-snap-type: none;
    --project-card-flex: 1 1 100%;
    --project-card-max-width: 100%;
    --project-card-more-button-width: 100%;
    --project-card-more-button-part-width: 100%;
    --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));
    --project-card-collapsed-extra-display: none;
  }
}

@container profile-pane (max-width: 576px) {
  .profile__section[data-profile-section='projects'],
  .profile__section--empty[data-profile-section='projects'] {
    --project-card-rail-wrap: wrap;
    --project-card-rail-overflow-x: visible;
    --project-card-rail-scroll-snap-type: none;
    --project-card-flex: 1 1 100%;
    --project-card-max-width: 100%;
    --project-card-more-button-width: 100%;
    --project-card-more-button-part-width: 100%;
    --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));
    --project-card-collapsed-extra-display: none;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/projects/ProjectSection.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;;EAEE,gDAAgD;EAChD,gCAAgC;EAChC,oCAAoC;EACpC,iDAAiD;EACjD,2CAA2C;EAC3C,uDAAuD;EACvD,8BAA8B;EAC9B,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,8DAA8D;EAC9D,wDAAwD;EACxD,yDAAyD;EACzD,qCAAqC;EACrC,0DAA0D;EAC1D,sCAAsC;EACtC,yDAAyD;EACzD,2DAA2D;EAC3D,sCAAsC;EACtC,2CAA2C;EAC3C,wEAAwE;EACxE,wCAAwC;EACxC,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iCAAiC;EACjC,qDAAqD;EACrD,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gDAAgD;EAChD,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,qDAAqD;EACrD,oDAAoD;EACpD,gDAAgD;EAChD,6EAA6E;EAC7E,uDAAuD;EACvD,6DAA6D;EAC7D,4CAA4C;EAC5C,8CAA8C;EAC9C,wDAAwD;EACxD,oEAAoE;EACpE,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kEAAkE;EAClE,WAAW;EACX,8CAA8C;EAC9C,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,8CAA8C;EAC9C,0FAA0F;EAC1F,mCAAmC;EACnC,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,mDAAmD;EACnD,sEAAsE;EACtE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0DAA0D;EAC1D,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,sEAAsE;EACtE,mDAAmD;EACnD,oEAAoE;EACpE,wDAAwD;EACxD,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,mBAAmB;;AAEnB;EACE,kDAAkD;EAClD,yDAAyD;EACzD,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,4CAA4C;EAC5C,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gEAAgE;EAChE,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,kDAAkD;EAClD,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA,mBAAmB;AACnB;;EAEE,8BAA8B;EAC9B,uCAAuC;EACvC,0CAA0C;EAC1C,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;EACtC,2CAA2C;EAC3C,oHAAoH;AACtH;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;;IAEE,8BAA8B;IAC9B,uCAAuC;IACvC,0CAA0C;IAC1C,6BAA6B;IAC7B,8BAA8B;IAC9B,sCAAsC;IACtC,2CAA2C;IAC3C,oHAAoH;IACpH,4CAA4C;EAC9C;AACF;;AAEA;EACE;;IAEE,8BAA8B;IAC9B,uCAAuC;IACvC,0CAA0C;IAC1C,6BAA6B;IAC7B,8BAA8B;IAC9B,sCAAsC;IACtC,2CAA2C;IAC3C,oHAAoH;IACpH,4CAA4C;EAC9C;AACF","sourcesContent":["/* Projects section styles. */\n\n.profile__section[data-profile-section='projects'],\n.profile__section--empty[data-profile-section='projects'] {\n  --project-card-rail-gap: var(--spacing-md, 1rem);\n  --project-card-rail-wrap: nowrap;\n  --project-card-rail-overflow-x: auto;\n  --project-card-rail-scroll-snap-type: x proximity;\n  --project-card-flex-basis: min(420px, 88vw);\n  --project-card-flex: 0 0 var(--project-card-flex-basis);\n  --project-card-max-width: none;\n  --project-card-scrollbar-height: 0.5rem;\n  --project-card-thumb-column-width: 88px;\n  --project-card-thumb-size: 4.125rem;\n  --project-card-follow-label-gap: var(--spacing-xxs, 0.3125rem);\n  --project-card-wrapper-gap: var(--spacing-2xs, 0.625rem);\n  --project-card-content-gap: var(--spacing-xxs, 0.3125rem);\n  --project-card-heading-gap: 0.1875rem;\n  --project-card-meta-margin-top: var(--spacing-xs, 0.75rem);\n  --project-card-meta-font-size: 0.86rem;\n  --project-card-footer-padding: var(--spacing-xs, 0.75rem);\n  --project-card-more-button-gap: var(--spacing-xs, 0.375rem);\n  --project-card-more-button-width: auto;\n  --project-card-more-button-part-width: auto;\n  --project-card-mobile-more-button-margin-top: var(--spacing-xs, 0.75rem);\n  --project-card-more-button-margin-top: 0;\n  --project-card-collapsed-extra-display: flex;\n  --project-card-more-icon-transform: rotate(0deg);\n}\n\n/* Rail and cards */\n.project-card__rail {\n  display: flex;\n  gap: var(--project-card-rail-gap);\n  overflow-x: var(--project-card-rail-overflow-x, auto);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  flex-wrap: var(--project-card-rail-wrap, nowrap);\n  scroll-snap-type: var(--project-card-rail-scroll-snap-type, x proximity);\n}\n\nsolid-ui-button.project-card__follow-button {\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  gap: var(--project-card-follow-label-gap);\n  --button-border-width: var(--border-width-sm, 0.1rem);\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\n  --button-font-weight: var(--font-weight-md, 500);\n  --button-padding-sm: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);\n  --button-border-radius: var(--border-radius-md, 0.5rem);\n  --button-background: var(--color-card-bg, var(--white, #FFF));\n  --button-text: var(--color-primary, #7C4DFF);\n  --button-border: var(--color-primary, #7C4DFF);\n  --button-hover-background: var(--color-primary, #7C4DFF);\n  --button-hover-text: var(--color-text-on-action, var(--white, #FFF));\n  --button-hover-border: var(--color-primary, #7C4DFF);\n}\n\n.project-card__follow-label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--project-card-follow-label-gap);\n}\n\n.project-card__follow-label--hover {\n  display: none;\n}\n\n.project-card__follow-label--loading {\n  display: none;\n  align-items: center;\n  gap: var(--project-card-follow-label-gap);\n}\n\nsolid-ui-button.project-card__follow-button:hover .project-card__follow-label--default,\nsolid-ui-button.project-card__follow-button:focus-visible .project-card__follow-label--default,\nsolid-ui-button.project-card__follow-button:focus-within .project-card__follow-label--default {\n  display: none;\n}\n\nsolid-ui-button.project-card__follow-button:hover .project-card__follow-label--hover,\nsolid-ui-button.project-card__follow-button:focus-visible .project-card__follow-label--hover,\nsolid-ui-button.project-card__follow-button:focus-within .project-card__follow-label--hover {\n  display: inline-flex;\n}\n\nsolid-ui-button.project-card__follow-button[data-loading='true'] {\n  pointer-events: none;\n}\n\nsolid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--default,\nsolid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--hover {\n  display: none;\n}\n\nsolid-ui-button.project-card__follow-button[data-loading='true'] .project-card__follow-label--loading {\n  display: inline-flex;\n}\n\nsolid-ui-button.project-card__follow-button[data-loading='true'] .loading-spinner {\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n  border-width: 0.125rem;\n}\n\n.project-card__rail::-webkit-scrollbar {\n  height: var(--project-card-scrollbar-height);\n}\n\n.project-card__rail::-webkit-scrollbar-thumb {\n  background: var(--color-icon-muted, #90A1B9);\n  border-radius: 999px;\n}\n\n.project-card {\n  display: flex;\n  flex-direction: column;\n  flex: var(--project-card-flex, 0 0 var(--project-card-flex-basis));\n  width: 100%;\n  max-width: var(--project-card-max-width, none);\n  min-width: 0;\n  box-sizing: border-box;\n  scroll-snap-align: start;\n  border-radius: var(--border-radius-md, 0.5rem);\n  border: var(--border-width-sm, 0.1rem) solid var(--color-border, var(--gray-200, #E5E7EB));\n  padding: var(--spacing-md, 1.25rem);\n  justify-content: center;\n  align-items: flex-start;\n  gap: var(--spacing-sm, 0.938rem);\n  flex-shrink: 0;\n}\n\n.project-card__link {\n  display: block;\n  width: 100%;\n  align-self: stretch;\n  color: inherit;\n  text-decoration: none;\n}\n\n.project-card__link:hover .project-card__title,\n.project-card__link:focus-visible .project-card__title {\n  text-decoration: underline;\n}\n\n.project-card__wrapper {\n  display: grid;\n  grid-template-columns: var(--project-card-thumb-column-width) 1fr;\n  gap: var(--project-card-wrapper-gap);\n  width: 100%;\n  align-items: start;\n  border-radius: var(--border-radius-md, 0.5rem);\n  border-bottom: 1px solid var(--color-border, var(--gray-200, #E5E7EB));\n}\n\n.project-card__thumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--project-card-thumb-size);\n  height: var(--project-card-thumb-size);\n  overflow: hidden;\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--color-surface-placeholder, var(--gray-200, #E5E7EB));\n  padding: 0.656rem var(--spacing-2xs, 0.625rem);\n  aspect-ratio: 1/1;\n}\n\n.project-card__thumb-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.project-card__thumb-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-size: 0.72rem;\n  color: var(--color-text-detail, var(--slate-500, #62748E));\n  text-transform: uppercase;\n  letter-spacing: 0.04rem;\n}\n\n.project-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--project-card-content-gap);\n  min-width: 0;\n}\n\n.project-card__heading-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--project-card-heading-gap);\n  min-width: 0;\n}\n\n.project-card__title,\n.project-card__organization,\n.project-card__category,\n.project-card__meta,\n.project-card__description {\n  margin: 0;\n}\n\n.project-card__title {\n  overflow: hidden;\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  text-overflow: ellipsis;\n  font-size: var(--font-size-lg, 1.125rem);\n  font-weight: var(--font-weight-bold, 600);\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n  align-self: stretch;\n}\n\n.project-card__organization {\n  color: var(--color-text-primary, var(--gray-700, #364153));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  line-height: 1.35;\n  align-self: stretch;\n}\n\n.project-card__category {\n  font-size: var(--font-size-xxs, 0.75rem);\n  font-weight: var(--font-weight-md, 500);\n}\n\n.project-card__category--project {\n  color: var(--purple-500, #AD46FF);\n}\n\n.project-card__category--community {\n  color: var(--yellow-700, #A65F00);\n}\n\n.project-card__category--unknown {\n  color: var(--color-text-control, var(--slate-700, #314158));\n}\n\n.project-card__meta {\n  margin-top: var(--project-card-meta-margin-top);\n  overflow-wrap: anywhere;\n  font-size: var(--project-card-meta-font-size, 0.86rem);\n}\n\n.project-card__footer {\n  display: flex;\n  justify-content: flex-start;\n  align-self: stretch;\n  margin-top: auto;\n  padding: var(--spacing-sm, 0.938rem) 0 0;\n}\n\n.profile__section[data-profile-section='projects'] .profile-section-inline-error {\n  margin-top: var(--spacing-sm, 0.938rem);\n  padding: var(--spacing-xs, 0.75rem);\n  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--dialog-error-background, var(--pink-500, #ffdde6));\n  color: var(--dialog-error-text, var(--red-600, #B00020));\n  text-align: left;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* Action buttons */\n\nsolid-ui-button.project-card__more-button {\n  width: var(--project-card-more-button-width, auto);\n  margin-top: var(--project-card-more-button-margin-top, 0);\n  --button-height-sm: 0;\n  --button-padding-x-sm: 0;\n  --button-background: transparent;\n  --button-border: transparent;\n  --button-text: var(--color-primary, #7C4DFF);\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n}\n\n.project-card__more-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: var(--project-card-more-icon-transform, rotate(0deg));\n  transition: transform var(--animation-duration, 0.2s) ease;\n}\n\nsolid-ui-button.project-card__more-button::part(button) {\n  align-items: center;\n  justify-content: center;\n  width: var(--project-card-more-button-part-width, auto);\n  gap: var(--project-card-more-button-gap, 0.375rem);\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--color-primary, #7C4DFF);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-bold, 600);\n  cursor: var(--profile-interactive-cursor, pointer);\n}\n\n/* Compact layout */\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='projects'],\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='projects'] {\n  --project-card-rail-wrap: wrap;\n  --project-card-rail-overflow-x: visible;\n  --project-card-rail-scroll-snap-type: none;\n  --project-card-flex: 1 1 100%;\n  --project-card-max-width: 100%;\n  --project-card-more-button-width: 100%;\n  --project-card-more-button-part-width: 100%;\n  --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));\n}\n\n.profile-section-collapsible[data-mobile-expanded=\"false\"] .project-card:nth-child(n + 3) {\n  display: var(--project-card-collapsed-extra-display, flex);\n}\n\nsolid-ui-button.project-card__more-button[data-mobile-expanded=\"true\"] .project-card__more-icon {\n  --project-card-more-icon-transform: rotate(180deg);\n}\n\n@media (max-width: 576px) {\n  .profile__section[data-profile-section='projects'],\n  .profile__section--empty[data-profile-section='projects'] {\n    --project-card-rail-wrap: wrap;\n    --project-card-rail-overflow-x: visible;\n    --project-card-rail-scroll-snap-type: none;\n    --project-card-flex: 1 1 100%;\n    --project-card-max-width: 100%;\n    --project-card-more-button-width: 100%;\n    --project-card-more-button-part-width: 100%;\n    --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));\n    --project-card-collapsed-extra-display: none;\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .profile__section[data-profile-section='projects'],\n  .profile__section--empty[data-profile-section='projects'] {\n    --project-card-rail-wrap: wrap;\n    --project-card-rail-overflow-x: visible;\n    --project-card-rail-scroll-snap-type: none;\n    --project-card-flex: 1 1 100%;\n    --project-card-max-width: 100%;\n    --project-card-more-button-width: 100%;\n    --project-card-more-button-part-width: 100%;\n    --project-card-more-button-margin-top: var(--project-card-mobile-more-button-margin-top, var(--spacing-xs, 0.75rem));\n    --project-card-collapsed-extra-display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
